// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"::{'is-negative-charge' : row.entity.payment < 0}\" ng-bind=\"::row.entity.payment | invEmpty\">\n    </div>\n</div>\n";
// Exports
module.exports = code;